import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import pinia from './store';
import { i18n } from './locales';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './assets/styles/reset.scss';
import directives from './directives';
import './assets/styles/theme/index.scss';
import { registerGlobalComponents } from '@/plugins/globalComponents';
import { getElementPlusLocale } from './config/element-plus-locale';

const app = createApp(App);

app.use(router).use(pinia).use(i18n).use(ElementPlus, { locale: getElementPlusLocale(i18n.global.locale.value) }).use(directives);

// 注册全局组件
registerGlobalComponents(app);

app.mount('#app');
